import * as React from "react";
const SvgVickyBohoClose = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-375f4ce9-b065-44a2-9348-35d59fa0d74f", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 68.72 68.73", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "68.02 2.83 65.9 .71 34.36 32.24 2.83 .71 .71 2.83 32.24 34.36 .71 65.9 2.83 68.02 34.36 36.48 65.9 68.02 68.02 65.9 36.48 34.36 68.02 2.83", style: {
  strokeMiterlimit: 10
} }));
export default SvgVickyBohoClose;
